<script lang="ts">
    import { isMobile } from "@app/services/isMobile";
    import { breadcrumbs } from "./breadcrumbs.store";
    let lastBreadcrumbItem: HTMLElement;
    let breadcrumbsContainer: HTMLElement;
    let scrolled = false;

    function makeSureLastBreadcrumbItemIsFullyVisible() {
        if (!lastBreadcrumbItem || !breadcrumbsContainer) {
            return;
        }
        const containerBox = breadcrumbsContainer.getBoundingClientRect();
        const lastBreadcrumbItemBox =
            lastBreadcrumbItem.getBoundingClientRect();
        if (
            breadcrumbsContainer.getBoundingClientRect().right <
            lastBreadcrumbItem.getBoundingClientRect().right
        ) {
            lastBreadcrumbItem.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center",
            });
        }
    }

    $: {
        if (lastBreadcrumbItem && !scrolled) {
            scrolled = true;
            setTimeout(makeSureLastBreadcrumbItemIsFullyVisible, 1);
        }
    }
</script>

<div
    class="text-xs text-slate-600 pt-2 w-full w-full"
    bind:this={breadcrumbsContainer}
>
    <p class="w-full truncate">
        {#each $breadcrumbs as breadcrumbItem, index}
            <span
                class="dir-aware-pr-2"
                class:hidden={isMobile() && index + 2 < $breadcrumbs.length}
            >
                <svelte:element
                    this={index === $breadcrumbs.length - 1 ? "span" : "a"}
                    href={breadcrumbItem.link}
                >
                    {breadcrumbItem.text}
                </svelte:element>
            </span>
            {#if index < $breadcrumbs.length - 1}
                <span
                    bind:this={lastBreadcrumbItem}
                    class:hidden={isMobile() && index + 3 < $breadcrumbs.length}
                >
                    <span class="dir-aware-pr-2">&raquo;</span>
                </span>
            {/if}
        {/each}
    </p>
</div>
